fragment CalcuraCalculatorFragment on CalcuraCalculator {
    id
    name
    description

    engine

    spreadsheet_filename
    formula

    field_mapping

    block_editor_data
    logic_editor_data

    fields {
        ...CalcuraFieldFragment
    }

    products {
        ...ProductFragment
    }

    categories {
        ...CategoryFragment
    }

}